import React from 'react';
import { shrinkValue } from './helpers/cellFormatters';

const Default = ({ params, field }) => {
    const value = params?.value;

    if (!value) {
        return <></>;
    }

    const displayValue = shrinkValue(value, field?.maxContentLength);

    return (
        <span
            style={{ wordWrap: 'break-word' }}
            dangerouslySetInnerHTML={{ __html: displayValue }}
        />
    );
};

export default Default;
